import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './Checkout.css';
import CheckoutForm from './CheckoutForm';
import UnauthorizedScripts from '../UnauthorizedScrips';

import PropTypes from 'prop-types';
import PayButton from '../shared/hoc/PayButton';
import { useHistory } from 'react-router-dom';
import { getAuthorizeScripts, sendUnathScriptNotification } from '../../store/action/scriptsAction';

function Checkout({ location, componetProps }) {
  const PaymentSummary = componetProps; // payment summary component

  const paymentRef = useRef();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { authorizedScripts, scriptsLoaded, scriptsFailedToLoad } = useSelector((state) => state.scripts);

  const [unauthScriptsDetected, setUnauthScriptsDetected] = useState(false);
  const [unauthScriptList, setUnauthScriptList] = useState([]);

  useEffect(() => {
    dispatch(getAuthorizeScripts());
  }, [dispatch]);

  useEffect(() => {
    if (!scriptsLoaded) return;

    const allScripts = Array.from(document.scripts);
    if (allScripts.length > authorizedScripts.length) {
      setUnauthScriptsDetected(true);
      return;
    }

    // Create a Set of authorized src values for fast lookup
    const authorizedSrcs = new Set(authorizedScripts.map((script) => script.src));
    const unauthorized = allScripts.filter((script) => {
      try {
        const fullSrc = script.src;

        // First try exact match from authorized list
        const isWhitelisted = authorizedSrcs.has(fullSrc);
        if (isWhitelisted) return false;

        // Match if script src starts with any trusted pattern
        const isTrusted = authorizedScripts.some((trustedPattern) => fullSrc.startsWith(trustedPattern.src) || fullSrc.endsWith(trustedPattern.src));

        return !isTrusted;
      } catch {
        return false; // ignore inline scripts or invalid URLs
      }
    });

    const hasUnathScripts = unauthorized.length > 0;

    if (hasUnathScripts) {
      setUnauthScriptList(unauthorized.map((script) => script.src));
    }
    setUnauthScriptsDetected(hasUnathScripts);
  }, [authorizedScripts, scriptsLoaded]);

  useEffect(() => {
    if (unauthScriptsDetected && unauthScriptList.length > 0) {
      dispatch(sendUnathScriptNotification(unauthScriptList));
    }
  }, [unauthScriptsDetected, unauthScriptList, dispatch]);

  const onPayClick = () => {
    if (!loading) {
      paymentRef.current.handlePayCheckOut();
    }
  };

  const onSuccess = () => {
    setLoading(false);
    console.log('onSuccess');
    return history.replace({
      pathname: '/completed',
      state: {
        type: 'success',
      },
    });
  };

  const onFailure = (err) => {
    setLoading(false);
    history.push({
      pathname: '/completed',
      state: {
        type: 'failure',
        error: err,
      },
    });
  };

  return (
    <div className='checkout-bg'>
      <PaymentSummary
        type={location.state.type}
        checkoutData={location.state.checkoutData}
      />
      {(unauthScriptsDetected || (!scriptsLoaded && scriptsFailedToLoad)) && (
        <UnauthorizedScripts/>
      )}
      {(!unauthScriptsDetected && scriptsLoaded) &&
      <div className='checkout-root'>
        <div className='checkout-wrapper'>
          <div className='checkout'>
            <div className='price-header'></div>
            <CheckoutForm
              ref={paymentRef}
              checkoutData={location?.state?.checkoutData}
              amount={location?.state?.amount}
              type={location?.state?.type}
              username={location.state.username}
              userEmail={location.state.email}
              onSuccess={onSuccess}
              onFailure={onFailure}
              setPayLoading={setLoading} /><div style={{ textAlign: 'center', marginTop: 20 }}>
              <PayButton
                handlePayAmount={onPayClick}
                amount={location?.state?.amount}
                paymentLoader={loading} />
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  );
}

Checkout.propTypes = {
  location: PropTypes.object,
  componetProps: PropTypes.elementType,
};

export default Checkout;
